import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import "./assets/css/reset.scss";
import "./assets/css/element-variables.scss";

import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast);

import VueResource from 'vue-resource'
Vue.use(VueResource)

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });

import axios from "@/utils/request";
Vue.prototype.$ajax = axios;

//调接口服务器地址
Vue.prototype.$etturl = process.env.VUE_APP_ETT_URL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
